import React, { forwardRef, useImperativeHandle, useState } from "react";
import { BarChart, Bar, XAxis } from "recharts";
import CardLayout from "../common/CardLayout";

export default forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setItems: setItems,
        hide: hide,
        show: show
    }));

    const [variableExpensesSum, setVariableExpensesSum] = useState(null);
    const [currentExpensesSum, setCurrentExpensesSum] = useState(null);
    const [currentExpensesDiffInPercentage, setCurrentExpensesDiffInPercentage] = useState(null);
    const [variableExpensesDiffInPercentage, setVariableExpensesDiffInPercentage] = useState(null);
    const [visible, setVisible] = useState(true);

    const hide = () => {
        setVisible(false);
    };

    const show = () => {
        setVisible(true);
    };

    const setItems = ({
        variableExpensesSum,
        currentExpensesSum,
        currentExpensesDiffInPercentage,
        variableExpensesDiffInPercentage
    }) => {
        setVariableExpensesSum(variableExpensesSum);
        setCurrentExpensesSum(currentExpensesSum);
        setCurrentExpensesDiffInPercentage(currentExpensesDiffInPercentage);
        setVariableExpensesDiffInPercentage(variableExpensesDiffInPercentage);
    };

    const LABEL_X = 20;
    const startY = -100;
    const YInterval = 30;

    const labelConfigurations = [
        { x: LABEL_X, y: startY, color: "#003f5c" },
        { x: LABEL_X, y: startY + YInterval, color: "#58508d" },
        { x: LABEL_X, y: startY + 2 * YInterval, color: "#bc5090" },
        { x: LABEL_X, y: startY + 3 * YInterval, color: "#ff6361" },
        { x: LABEL_X, y: startY + 4 * YInterval, color: "#ffa600" }
    ];

    const parsedItems = [];
    parsedItems.push({
        name: "שוטפות מול משתנות",
        variant: variableExpensesSum,
        current: currentExpensesSum
    });

    const index = 0;

    return visible ? (
        <CardLayout header={"שוטפות מול משתנות"}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row-reverse",
                    zIndex: 999
                }}
            >
                <svg width={200} height={150}>
                    <g>
                        <g>
                            <circle
                                cx={labelConfigurations[index].x + 100}
                                cy={labelConfigurations[index].y + 135}
                                r={8}
                                fill={"rgb(136, 132, 216)"}
                            />
                            <text
                                fill="black"
                                fontSize="15"
                                x={labelConfigurations[index].x + 80}
                                y={labelConfigurations[index].y + 140}
                                textAnchor="end"
                            >
                                {"הוצאות שוטפות"}
                            </text>
                            <text
                                fill="black"
                                fontWeight={"bold"}
                                fontSize="15"
                                x={labelConfigurations[index].x + 80}
                                y={labelConfigurations[index].y + 157}
                                textAnchor="end"
                            >
                                {currentExpensesSum}
                            </text>
                            <text
                                fill="black"
                                fontSize="15"
                                x={labelConfigurations[index].x + 80}
                                y={labelConfigurations[index].y + 176}
                                textAnchor="end"
                            >
                                {currentExpensesDiffInPercentage < 0 ? "" : "+"}
                                {currentExpensesDiffInPercentage}%
                            </text>
                        </g>
                        <g>
                            <circle
                                cx={labelConfigurations[index].x + 100}
                                cy={labelConfigurations[index].y + 205}
                                r={8}
                                fill={"rgb(130, 202, 157)"}
                            />
                            <text
                                fill="black"
                                fontSize="15"
                                x={labelConfigurations[index].x + 80}
                                y={labelConfigurations[index].y + 210}
                                textAnchor="end"
                            >
                                {"הוצאות משתנות"}
                            </text>
                            <text
                                fill="black"
                                fontWeight={"bold"}
                                fontSize="15"
                                x={labelConfigurations[index].x + 80}
                                y={labelConfigurations[index].y + 227}
                                textAnchor="end"
                            >
                                {variableExpensesSum}
                            </text>
                            <text
                                fill="black"
                                fontSize="15"
                                x={labelConfigurations[index].x + 80}
                                y={labelConfigurations[index].y + 246}
                                textAnchor="end"
                            >
                                {variableExpensesDiffInPercentage < 0 ? "" : "+"}
                                {variableExpensesDiffInPercentage}%
                            </text>
                        </g>
                    </g>
                </svg>
                <BarChart
                    width={200}
                    height={170}
                    data={parsedItems}
                    margin={{ top: 25, right: 30, left: 20, bottom: 5 }}
                >
                    <XAxis dataKey="name" />
                    <Bar dataKey="variant" fill="#82ca9d" />
                    <Bar dataKey="current" fill="#8884d8" />
                </BarChart>
            </div>
        </CardLayout>
    ) : (
        <div />
    );
});
